$(function(){
  $(document).on('click','.ag_header_search,.u_search_wrapper_close',function(){
    $('.ag_header_bg').toggleClass('u_header_bg')
    $('.u_search_wrapper').toggleClass('u_search_active')
  })
  $(document).on('keyup','.u_input_search',function(){
    let searchTerm = $(this).val();
    console.log('keyup',searchTerm)
    if(searchTerm.length != 0){
      console.log('if condition',searchTerm.length)
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=query,product,collection,page,article&section_id=predictive-search`)
    .then((response)=>{
      if(response.status == '200'){
        $('.u_animated_cont').show()
        $('body').addClass('u_body_overflow')
      return response.text()        
      }

    })
    .then((resolve)=>{
      setTimeout(function(){
         $('.u_search_wrapper_right').hide()        
      $('.u_predictive_body').show().html(resolve)  
        $('.u_search_wrapper_bottom_head').hide()
      },1000)
    }).
      catch((err)=>{
       console.log('error',err) 
      })
}
  else{
          console.log('if condition',searchTerm.length)
      $('.u_predictive_body').empty().hide()
    $('body').removeClass('u_body_overflow')
            $('.u_search_wrapper_bottom_head').show()
     $('.u_search_wrapper_right').show()  
  }
})
})